import Image from '@anm/components/image/Image';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const ImageWrapper = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  padding: 3px;
  border: 2px solid #292a2b;
  margin: 0 auto 8px;
`;

export const Title = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #292a2b;
  margin: 0;
`;

export const ThumbnailImage = styled(Image)`
  object-fit: cover;
  display: block;
  margin: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const ContentWrapper = styled.div`
  width: 100px;
  margin: 10px;
  cursor: pointer;
`;
